import React, { useState, useContext } from "react";
import "../Styles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
// import { OffLineAPI } from "../../../offline-auth/api";
import { isValidPhoneNumber } from "react-phone-number-input";

import { updateUser, updateProfile } from "../../../actions/users";
import "../../doctor/doctorProfile/doctorProfile.css";
import "../../../ui-styles/profile/VrtclProfile.css";
import "../../../ui-styles/profile/ProfileDetails.css";
import "../../../ui-styles/list/EditProfileImage.css";
import Loader from "../../../lib/ui/loader/Loader";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import { validateEmail, validateLetters, validateIntegers } from "../../../lib/validation";
import { toast } from "react-toastify";
import EditClinicProfile from "./EditClinicProfile";
import { Auth } from "aws-amplify";
import ProfileImage from "../../common/profileImage";
import { addrLangObj } from "../../../locale/address";
import { parsePhoneNumber } from "react-phone-number-input";

const ClinicProfile = (props) => {
    const [editProfile, setEditProfile] = useState(false);
    const { l } = useContext(LangCtx);
    const al = addrLangObj[l.locale];
    const { payload, getPayLoad } = useContext(PayLoadCtx);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const [error, setError] = useState({});
    // const [clinic, setClinic] = useState({});
    const [editedClinic, setEditedClinic] = useState({});


    const handleEditProfle = () => {
    setEditProfile((prevState) => {
        if (!prevState) {
            setEditedClinic({
                ...payload,
                phone: payload?.countryCode ? `+${payload?.countryCode}${payload?.phone}` :payload?.phone,
            });
        }
        return !prevState;
    });
    setError({})
    };

    // useEffect(() => {
    //    setClinic({
    //     ...payload,
    //      phone: payload?.countryCode ? `+${payload?.countryCode}${payload?.phone}` :payload?.phone,
    //    })
    // }, []);

    // const loadClinic = () => {
    //     setLoading(true);
    //     getUserDetails(payload.userId)
    //         .then((res) => {
    //             // console.log("res=============", res);
    //             if (res.status) {
    //                 setClinic({
    //                     ...res.data,
    //                     phone: res.data?.countryCode ? `+${res?.data?.countryCode}${res?.data?.phone}` : res?.data?.phone,
    //                 });
    //                 setEditedClinic({
    //                     ...res.data,
    //                     phone: res.data?.countryCode ? `+${res?.data?.countryCode}${res?.data?.phone}` : res?.data?.phone,
    //                 });
    //                 setLoading(false);
    //             }
    //         })
    //         .catch((err) => {
    //             setLoading(false);
    //             let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
    //             toast.error(msg, {
    //                 position: toast.POSITION.TOP_RIGHT,
    //             });
    //             console.log("err ==== ", err);
    //         });
    // };

    const handleChange = (e) => {
        let _editedClinic = { ...editedClinic };
        _editedClinic = {
            ..._editedClinic,
            [e.target.name]: e.target.value,
            // [ name ]: value
        };
        if (e.target.name === "country") {
            _editedClinic.stateName = "";
            _editedClinic.city = "";
        }
        setEditedClinic(_editedClinic);
        setError({...error, [e.target.name] : "" })
    };

    const validateForm = () => {
        let _error = {};
        let returnValue = true;

        if (editedClinic.clinicName === "" || editedClinic.clinicName == null) {
            _error["clinicName"] = l.pls_ent_clcName;
            returnValue = false;
        } 
        if (editedClinic.contactName === "" || editedClinic.contactName == null) {
            _error["contactName"] = l.pls_ent_contName;
            returnValue = false;
        } else if (!validateLetters(editedClinic.contactName)) {
            _error["contactName"] = l.pls_ent_clc_contact;
            returnValue = false;
        }
        if (editedClinic.email === "" || editedClinic.email == null) {
            _error["email"] = l.pls_enter_email;
            returnValue = false;
        } else if (!validateEmail(editedClinic.email)) {
            _error["email"] = l.pls_check_email;
            returnValue = false;
        }
        if (editedClinic.phone && !isValidPhoneNumber(editedClinic.phone)) {
            _error["phone"] = l.pls_check_ph_number;
            returnValue = false;
        }
        // if (editedClinic.country === '' || editedClinic.country == null) {
        //     _error['country'] = l.pls_sel_country
        //     returnValue = false
        // }
        // if (editedClinic.stateName === '' || editedClinic.stateName == null) {
        //     _error['state'] = l.pls_sel_state
        //     returnValue = false
        // }
        // if (editedClinic.city === '' || editedClinic.city == null) {
        //     _error['city'] = l.pls_sel_city
        //     returnValue = false
        // }
        // if (editedClinic.pincode === '' || editedClinic.pincode === null) {
        //     _error['pincode'] = l.pls_entr_pin
        //     returnValue = false
        // } 
        if (editedClinic.pincode !== '' && !validateIntegers(editedClinic.pincode)) {
            _error['pincode'] = l.pls_check_pin
            returnValue = false
        }
        setError(_error);
        return returnValue;
    };

    const handlePhoneChange = (value) => {
        setEditedClinic((prevState) => {
            return { ...prevState, phone: value };
        });

        if (value === "" && value === undefined) {
            setErrorMsg(l.pls_enter_phne);
            return;
        } else if (value && (value !== "" || value !== undefined)) {
            if (!isValidPhoneNumber(value)) {
                setErrorMsg(l.pls_check_ph_number);
                return;
            } else {
                setErrorMsg("");
            }
        } else {
            setErrorMsg(l.pls_enter_phne);
        }
    };

    const handleUpdateClinic = (e) => {
        e.preventDefault();
        try {
            if (validateForm()) {
                const phoneNumber = parsePhoneNumber(editedClinic?.phone);
                if (!phoneNumber) {
                    setErrorMsg("Please enter a valid phone number.");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    return;
                }
                const countrycode = phoneNumber?.countryCallingCode.toString();
                const number = phoneNumber.nationalNumber;
                setLoading(true);
                let body = {
                    clinicName: editedClinic.clinicName.trim(),
                    // firstName: editedClinic.clinicName.trim(),
                    lastName: "",
                    consultRole: "clinic",
                    countryCode: countrycode,
                    //  clinicId: clinicId,
                    contactName: editedClinic.contactName.trim(),
                    email: editedClinic.email.trim(),
                    phone: number ? number : "",
                    address: editedClinic?.address ? editedClinic.address.trim() : "",
                    country: editedClinic.country ? editedClinic.country : "",
                    stateName: editedClinic.stateName ? editedClinic.stateName : "",
                    city: editedClinic.city ? editedClinic.city : "",
                    pincode: editedClinic.pincode ? editedClinic.pincode : "",
                };
                if (process.env.REACT_APP_isOffline === "true") {
                    updateUser(payload.userId, body)
                        .then((res) => {
                            if (res.status) {
                                // loadClinic();
                                // handleEditProfle();
                                setLoading(false);
                                toast.success(l.upd_succ, {
                                    position: toast.POSITION.TOP_RIGHT,
                                });
                                // setClinic(null);
                                setEditProfile((prevState) => !prevState);
                                getPayLoad();
                            }
                        })
                        .catch((err) => {
                            console.log("err", err);
                            setLoading(false);
                            let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
                            toast.error(msg, {
                                position: toast.POSITION.TOP_RIGHT,
                            });
                            setErrorMsg(l.unable_upd_clinic);
                        });
                } else {
                    Auth.currentAuthenticatedUser()
                        .then((user) => {
                            Auth.updateUserAttributes(user, {
                                "custom:fname": editedClinic.clinicName.trim(),
                                // 'custom:Country': editedClinic.country,
                                // 'custom:State': editedClinic.stateName,
                                // 'custom:District': editedClinic.city
                            }).then((result) => {
                                updateProfile(body)
                                    .then((res) => {
                                        if (res.status) {
                                            // loadClinic();
                                            // handleEditProfle();
                                            setLoading(false);
                                            toast.success(l.upd_succ, {
                                                position: toast.POSITION.TOP_RIGHT,
                                            });
                                            // setClinic(null);
                                            setEditProfile((prevState) => !prevState);
                                            getPayLoad();
                                        }
                                    })
                                    .catch((err) => {
                                        setLoading(false);
                                        let msg = err?.response?.data?.error?.message
                                            ? err.response.data.error.message
                                            : err?.response?.data?.error
                                            ? err.response.data.error
                                            : err.errorMessage;
                                        toast.error(msg, {
                                            position: toast.POSITION.TOP_RIGHT,
                                        });
                                        setErrorMsg(l.unable_upd_clinic);
                                    });
                            });
                        })
                        .catch((err) => {
                            console.log("err in currentAuthenticatedUser === ", err);
                        });
                }
            } else {
                if (errorMsg != null) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                }
            }
        } catch (err) {
            console.log("errrr-----------", err);
            setLoading(false);
            let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage;
            toast.error(msg, {
                position: toast.POSITION.TOP_RIGHT,
            });
            setErrorMsg(err?.response?.data?.error);
        }
    };

    return loading ? (
        <Loader />
    ) : payload != null ? (
        <div className="baseContainer">
            {/* <div className="hdngTopCol">
                <div className="hdngTopBox">
                    <h2 className="topHdngTxt">ClinicProfile</h2>
                </div>
            </div>
            <div className="ptntLstCntnr">

            </div> */}
            <div className="myProfleContainer">
                <div className="vrtclProfileCol">
                    <ProfileImage userDetails={payload} userRole={"C"} />
                    <div className="profileDtlsCol">
                        <div className="profleHdngRow">
                            <span className="profileSHdgn">{l.contact_details}</span>
                            <div className="proflieEdit" onClick={handleEditProfle}>
                                <img src="/images/icons/edit-outline.png" className="inlineIcon invertPrimary" alt="icon" />
                                <small className="inlinetxt">{l.edit}</small>
                            </div>
                        </div>

                        <ul className="profileGroupCol">
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.clc_username}</span>
                                <span className="profileInfoTxt dark">{payload.clinicName ? payload.clinicName : ""}</span>
                            </li>
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.clc_contact_name}</span>
                                <span className="profileInfoTxt dark">{payload.contactName ? payload.contactName : ""}</span>
                            </li>
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.label_phone_no}</span>
                                <span className="profileInfoTxt dark">{payload.phone ? payload?.countryCode ? `+${payload?.countryCode}${payload?.phone}` :payload?.phone : "--"}</span>
                            </li>
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.label_email}</span>
                                <span className="profileInfoTxt dark">{payload.email ? payload.email : ""}</span>
                            </li>
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.label_address}</span>
                                <span className="profileInfoTxt dark">{payload.address ? payload.address : ""}</span>
                            </li>
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.country}</span>
                                <span className="profileInfoTxt dark">{payload.country ? payload.country : ""}</span>
                            </li>
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.label_city}</span>
                                <span className="profileInfoTxt dark">{payload.city ? al[payload.city] : ""}</span>
                            </li>
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.label_state}</span>
                                <span className="profileInfoTxt dark">{payload.stateName ? al[payload.stateName] : ""}</span>
                            </li>
                            <li className="profileListItem">
                                <span className="profileInfoTxt">{l.label_pin}</span>
                                <span className="profileInfoTxt dark">{payload.pincode ? payload.pincode : ""}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {editProfile && (
                <EditClinicProfile
                    editProfile={editProfile}
                    handleChange={handleChange}
                    handleUpdateClinic={handleUpdateClinic}
                    handleEditProfle={handleEditProfle}
                    data={editedClinic}
                    errorMsg={errorMsg}
                    error={error}
                    handlePhoneChange={handlePhoneChange}
                />
            )}
        </div>
    ) : (
        ""
    );
};

export default ClinicProfile;
